import React from "react";

const PedicureNearMeProcess = () => {
  return (
    <div className="hairSalonNearMeService">
      <h3>A Step-by-Step Look at Our Pedicure Process</h3>
      <p>
        Curious about what happens when you visit SCENT for a pedicure? Here’s
        an overview of our signature process:
      </p>

      <li>
        <h6>1. Consultation</h6>
        <p>
          We begin by understanding your needs and preferences to customize the
          experience.
        </p>
      </li>
      <li>
        <h6>2. Soaking</h6>
        <p>
          Your feet are soaked in a warm, aromatic bath to soften the skin and
          relax the muscles.
        </p>
      </li>
      <li>
        <h6> 3. Exfoliation</h6>
        <p>
          Dead skin cells are gently removed using a scrub tailored to your skin
          type.
        </p>
      </li>
      <li>
        <h6> 4. Nail Care</h6>
        <p> Nails are trimmed, shaped, and buffed to perfection.</p>
      </li>
      <li>
        <h6> 5. Massage</h6>
        <p>
          A soothing foot massage enhances blood circulation and leaves you
          feeling rejuvenated.
        </p>
      </li>
      <li>
        <h6>6. Polish Application</h6>
        <p>
          Choose from a wide range of colors for a polished, professional
          finish.
        </p>
      </li>
    </div>
  );
};

export default PedicureNearMeProcess;
